import { Capacitor } from '@capacitor/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import type { StateStorage } from 'zustand/middleware';

const LEGACY_KEY = 'indap_auth_state';

/**
 * Almacenamiento para persist de Zustand: `localStorage` en web/PWA y
 * Keychain/Keystore vía @aparajita/capacitor-secure-storage en iOS/Android.
 */
export function createAuthPersistStorage(): StateStorage {
  return {
    getItem: async (name: string): Promise<string | null> => {
      if (Capacitor.isNativePlatform()) {
        try {
          const v = await SecureStorage.getItem(name);
          if (v != null) return v;
        } catch {
          /* clave ausente u otro error */
        }
        const legacy = localStorage.getItem(name);
        if (legacy) {
          try {
            await SecureStorage.setItem(name, legacy);
          } catch (e) {
            console.warn('Auth persist: no se pudo migrar a almacenamiento seguro', e);
          }
          localStorage.removeItem(name);
        }
        return legacy;
      }
      return localStorage.getItem(name);
    },
    setItem: async (name: string, value: string): Promise<void> => {
      if (Capacitor.isNativePlatform()) {
        await SecureStorage.setItem(name, value);
        localStorage.removeItem(name);
        return;
      }
      localStorage.setItem(name, value);
    },
    removeItem: async (name: string): Promise<void> => {
      if (Capacitor.isNativePlatform()) {
        try {
          await SecureStorage.removeItem(name);
        } catch {
          /* */
        }
      }
      localStorage.removeItem(name);
    },
  };
}

/** Limpia posible copia legada en localStorage tras migración a nativo. */
export function limpiarLegacyAuthLocalStorage(): void {
  if (Capacitor.isNativePlatform() && localStorage.getItem(LEGACY_KEY)) {
    localStorage.removeItem(LEGACY_KEY);
  }
}
